export const editFontFamilyModal = {};